/*
  Are notifications still reaching this device? Ported from Tazkiyah's useReach: phones quietly
  start holding notifications back weeks after setup (battery saving, "sleeping apps", a Focus
  mode), so the check runs every time the app comes to the front, not once. The server counts
  pushes the device never confirmed; three in a row means "missing".
*/
import { useDeviceHealthMutation } from "app/services/notifications";
import storage, { STORAGE_PREFIX } from "app/utils/storage";
import { useCallback, useEffect, useState } from "react";
import { isNativeApp } from "./nativeApp";
import { currentWebSubscription, getPhoneToken } from "./push";

const SNOOZE_KEY = `${STORAGE_PREFIX}app-reachSnoozed`;

export function useReach() {
  const [check] = useDeviceHealthMutation();
  const [missing, setMissing] = useState(false);

  const run = useCallback(async () => {
    try {
      const snoozed = storage.getItem(SNOOZE_KEY);
      if (snoozed && Date.now() - Number(snoozed) < 86400000) { setMissing(false); return; }
      const body = isNativeApp() ? (getPhoneToken() ? { token: getPhoneToken()! } : null) : await currentWebSubscription().then((s) => (s ? { endpoint: s.endpoint } : null));
      if (!body) { setMissing(false); return; }
      const r = await check(body).unwrap();
      setMissing(Boolean(r.registered && r.missing));
    } catch { /* offline: try again next time */ }
  }, [check]);

  useEffect(() => {
    void run();
    const onVisible = () => { if (document.visibilityState === "visible") void run(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [run]);

  const snooze = () => { storage.setItem(SNOOZE_KEY, String(Date.now())); setMissing(false); };
  return { missing, snooze, recheck: run };
}
